import React from 'react'
import styles from './FilePreview.module.scss'

const PlayIcon = () => {
    return (


        <svg className={`${styles.playIcon} play-icon`} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.24 29.88">

            <path d="M25.55,13.74L2.07.19C1.15-.34,0,.32,0,1.39v27.11c0,1.06,1.15,1.73,2.07,1.2l23.48-13.56c.92-.53.92-1.86,0-2.4Z" />
        </svg>


    )
}

export default PlayIcon
